import { Stack } from "expo-router";
import { ActivityIndicator } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { useAuth, useTenant, useTenantReady, AccountNotConfiguredView } from "@src/features/tenants";
import { View } from "@src/components";

export default function TabsLayout() {
  const { theme } = useUnistyles();
  const { isAuthenticated } = useAuth();
  const { selectedTenant, refreshTenants, error: tenantError } = useTenant();
  const { isReady, isEmpty, isLoading: isLoadingTenants } = useTenantReady();

  const hasTenant = isAuthenticated && !!selectedTenant?.id;
  const showNoTenantView = isAuthenticated && !hasTenant && isReady && (!!tenantError || isEmpty);

  if (!hasTenant && !showNoTenantView) {
    return (
      <View flex={1} alignItems="center" justifyContent="center" bg="background">
        <ActivityIndicator size="large" />
      </View>
    );
  }

  if (showNoTenantView) {
    return <AccountNotConfiguredView error={tenantError?.message} onRetry={() => void refreshTenants()} />;
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: {
          backgroundColor: theme.colors.background,
        },
      }}
    />
  );
}
